function Settings() {
  return (
    <div>
      <h2>Configuración</h2>
      <p>Aquí podrás configurar tu sistema próximamente.</p>
    </div>
  );
}

export default Settings;